import theme from "@/styles/theme";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { grey } from "@mui/material/colors";
import Link from "next/link";

export const BandSendMessageButton = ({ title, href, disabled, onClick }) => {
  const buttonStyles = {
    borderWidth: "2px",
    borderStyle: "solid",
    borderColor: disabled ? grey[400] : theme.palette.secondary.main,
    color: theme.palette.secondary.main,
    borderRadius: "0",
    height: "2.5rem",
    width: "2.5rem",
    transition: "all .2s ease-in-out",
    p: 0,
    "&:hover": {
      borderColor: theme.palette.common.white,
      "& .MuiSvgIcon-root": {
        color: theme.palette.secondary.main,
      },
    },
    "& .MuiSvgIcon-root": {
      fontSize: 24,
      transition: "all .2s ease-in-out",
    },
  };

  return (
    <Tooltip title={title}>
      <span>
        {disabled ? (
          <IconButton
            sx={buttonStyles}
            onClick={onClick}
            aria-label="Nachricht schreiben"
            disabled
          >
            <ChatBubbleIcon />
          </IconButton>
        ) : (
          <Link href={href}>
            <IconButton
              sx={buttonStyles}
              onClick={onClick}
              aria-label="Nachricht schreiben"
              disabled={disabled}
            >
              <ChatBubbleIcon />
            </IconButton>
          </Link>
        )}
      </span>
    </Tooltip>
  );
};
